import React, { useEffect } from "react";
import "./BenefitsSection.css";
import { FaTint, FaHandsHelping, FaUtensils, FaChild, FaSpa, FaBullhorn } from "react-icons/fa";

const BenefitsSection = () => {
  useEffect(() => {
    const boxes = document.querySelectorAll(".benefit-box, .center-circle");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (entry.target.classList.contains("left")) {
              entry.target.classList.add("animate-left");
            } else if (entry.target.classList.contains("right")) {
              entry.target.classList.add("animate-right");
            } else if (entry.target.classList.contains("center-circle")) {
              entry.target.classList.add("animate-center");
            }
          }
        });
      },
      { threshold: 0.2 }
    );

    boxes.forEach((box) => observer.observe(box));
  }, []);

  return (
    <section className="benefits-section">
      {/* Section Heading */}
      <div className="benefits-heading">
        <h2>Our Key Initiatives</h2>
        <p>We work together to bring positive change in society.</p>
      </div>

      {/* Left Column */}
      <div className="benefits-column">
        <div className="benefit-box left">
          <div className="benefit-icon"><FaTint /></div>
          <div>
            <h3>Blood Donation Camps</h3>
            <p>Organizing regular blood donation camps to save lives.</p>
          </div>
        </div>

        <div className="benefit-box left">
          <div className="benefit-icon"><FaHandsHelping /></div>
          <div>
            <h3>Self Help Groups</h3>
            <p>Supporting communities through skill-based self help groups.</p>
          </div>
        </div>

        <div className="benefit-box left">
          <div className="benefit-icon"><FaUtensils /></div>
          <div>
            <h3>Food & Cleanliness Drives</h3>
            <p>Providing meals and ensuring hygiene through campaigns.</p>
          </div>
        </div>
      </div>

      {/* Center Image */}
      <div className="benefits-center">
        <div className="circle-overlay"></div>
        <div className="center-circle">
          <img src="/assets/bloodlogo.png" alt="Initiatives" />
        </div>
      </div>

      {/* Right Column */}
      <div className="benefits-column">
        <div className="benefit-box right">
          <div className="benefit-icon"><FaChild /></div>
          <div>
            <h3>Divyang Children Programs</h3>
            <p>Special education and support for differently-abled children.</p>
          </div>
        </div>

        <div className="benefit-box right">
          <div className="benefit-icon"><FaSpa /></div>
          <div>
            <h3>Stress Management</h3>
            <p>Workshops on mindfulness, yoga, and stress-free living.</p>
          </div>
        </div>

        <div className="benefit-box right">
          <div className="benefit-icon"><FaBullhorn /></div>
          <div>
            <h3>Awareness Campaigns</h3>
            <p>Spreading awareness about health and social issues.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
